// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1u-q";
export var animationRelative = "_1u-p";
export var backdropBlur = "_1u-0";
export var detailLabelCell = "_1u-12";
export var detailTable = "_1u-11";
export var detailValueCell = "_1u-13";
export var docIconBox = "_1u-1d";
export var docIconBoxMd = "_1u-1f";
export var docIconBoxSm = "_1u-1e";
export var docTypeRow = "_1u-16";
export var docTypeRowInner = "_1u-17";
export var dropdownMatchDatePicker = "_1u-3";
export var evidenceCardContent = "_1u-1c";
export var fileUploadSpin = "_1u-j";
export var gorgiasOpenButton = "_1u-15 _1u-d";
export var gorgiasTicketCard = "_1u-14";
export var heroModalFooterButton = "_1u-18";
export var hiddenContainer = "_1u-o";
export var iconPrimary = "_1u-1g";
export var iconSecondary = "_1u-1h";
export var iconTertiary = "_1u-1i";
export var integrationCard = "_1u-1";
export var integrationLogoBox = "_1u-2";
export var mainColumnSticky = "_1u-1b";
export var maxWidthContainer = "_1u-19";
export var modalContentBody = "_1u-a";
export var modalHeaderImage = "_1u-5";
export var modalImageLabel = "_1u-7";
export var modalImageOverlay = "_1u-6";
export var modalImageSubtitle = "_1u-9";
export var modalImageTitle = "_1u-8";
export var modalImageWrapper = "_1u-4";
export var modalStickyFooter = "_1u-b";
export var removeButton = "_1u-e";
export var sidebarColumn = "_1u-1a";
export var spinner = "_1u-i";
export var timelineLine = "_1u-y";
export var timelineLineBlack = "_1u-10 _1u-y";
export var timelineLineGray = "_1u-z _1u-y";
export var timelineLineHeight = "_1u-x";
export var tlDotActivate = "_1u-u";
export var tlDotActivateAnim = "_1u-t";
export var tlDotHide = "_1u-s";
export var tlDotHideAnim = "_1u-r";
export var tlLineActivate = "_1u-w";
export var tlLineActivateAnim = "_1u-v";
export var uploadHint = "_1u-n";
export var uploadIconBox = "_1u-k";
export var uploadLabel = "_1u-m";
export var uploadText = "_1u-l";
export var uploadZone = "_1u-f";
export var uploadZoneCursorDefault = "_1u-h";
export var uploadZoneCursorPointer = "_1u-g";
export var uploadedFileRow = "_1u-c";
export var viewButton = "_1u-d";